/*==========================================================
INITIALIZE INTERIOR SCRIPT
==========================================================*/

// PHOTO GALLERY
//$(function() {
//    $(".eSolutionsGroupPhotoGalleryV2PlaceholderDiv").each(function () {
//        var method = $(this).attr("method");
//        var id = $(this).attr("id");
//        if (id != '') {
//            $(this).load(id, function () {
//                $(this).find(".prev.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_PreviousArrow"]);
//                $(this).find(".next.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_NextArrow"]);
//                $(this).find(".pause.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Pause"]);
//                $(this).find(".pause.paused.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Play"]);
//                $(this).find(".pause.keyboardnav").on('click', function (e) {
//                    if ($(e.target).hasClass("paused")) {
//                        $(e.target).attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Pause"]);
//                    } else {
//                        $(e.target).attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Play"]);
//                    }
//                });
//                return method;
//            });
//        } else {
//            $(this).html('');
//        }
//    });
//});

//Scripts to wrap tables
if ((!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) && !isFrontEndDev) {
    function icrt_table_resize() {
        var contentWidth = ($('#printAreaContent').width());
        $('#printAreaContent table').each(function (index,item) {
            var contentRow = $(item).closest('.fbg-row');
            if ((contentRow.length && $(this).width() > $(contentRow).width()) || $(this).width() > contentWidth) {
                if ($(this).parent('.tableContainer').length === 0) {
                    $(this).wrap('<div class="tableContainer" />');
                    var wideTable = $(this).addClass('wideTable');
                    var wideTableContainer = $(wideTable).parent();
                    $('<div class="tableContainerHead">' + iCreateObject.languageResources['Common_Includes_headInterior_TableScrollMessage'] + '</div>').insertBefore(wideTableContainer);
                }
            } else if ((contentRow.length && $(this).width() <= $(contentRow).width()) || $(this).width() <= contentWidth) {
                if ($(this).parent('.tableContainer').length > 0) {
                    $(this).parent().siblings('.tableContainerHead').detach();
                    $(this).unwrap();
                    $(this).removeClass('wideTable');
                }
            }
        });
    }

    $(document).ready(function () {
        $('.AccordionTrigger').on('click', function () {
            icrt_table_resize();
        });
    });

    $(window).load(function () {
        setTimeout(function () {
            icrt_table_resize();
        }, 0);
    });

    $(window).resize(function () {
        setTimeout(function () {
            icrt_table_resize();
        }, 0);
    });
}
